import { render, staticRenderFns } from "./cdn-logo.vue?vue&type=template&id=3e70a474&"
import script from "./cdn-logo.vue?vue&type=script&lang=js&"
export * from "./cdn-logo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports